const ParameterType = Object.freeze({
    river: 1,
    rainfall: 2,
    tidal: 3
});

RegExp.escape = function (s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
};

const Html = {
    escape: function (unsafe) {
        return unsafe // From https://stackoverflow.com/a/6234804
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    },
    wrap: function wrap(item, searchText, startTag, endTag) {
        var regex = new RegExp(RegExp.escape(Html.escape(searchText)), "gi");
        return Html.escape(item).replace(regex, (match) => `${startTag}${match}${endTag}`);
    },
    renderTemplate: function (templateHtmlString, componentMap) {
        /*
            <div data-component="myComponent"></div>
            
            This div would be replaced with the "myComponent" component in componentMap by using myComponent's render() method,
            which must return a DOMElement or an array of them.
        */
        let $dom = $(templateHtmlString);
        let root = $("<div></div>")[0];

        $(root).append($dom);

        let componentKeys = Object.keys(componentMap);
        for (let i = 0; i < componentKeys.length; i++) {
            let key = componentKeys[i];
            let component = componentMap[key];

            let divToReplace = root.querySelector(`[data-component="${key}"]`);

            let domToReplaceWith = component.render ? component.render() : $(`<p>MISSING COMPONENT ${key}</p>`)[0];

            $(divToReplace).replaceWith(domToReplaceWith);
        }

        return $(root).children().get();
    },
    staticComponent: function (element) {
        return {
            element: element,
            render: function () {
                return element;
            }
        };
    }

};

const Language = {
    // Usage: Text.localise(station.name, s => s.english, s => s.welsh)
    // This function will try to use known defaults (like .english, .en, .welsh, .cymraeg. .cy)
    text: function (object, englishFn, welshFn) {
        if (typeof englishFn === typeof undefined) {
            let englishProperties = ["english", "en"];

            for (let i = 0; i < englishProperties.length; i++) {
                if (englishProperties[i] in object) {
                    englishFn = a => a[englishProperties[i]];
                    break;
                }
            }
        }

        if (typeof welshFn === typeof undefined) {
            let welshProperties = ["welsh", "cymraeg", "cy"];

            for (let i = 0; i < welshProperties.length; i++) {
                if (welshProperties[i] in object) {
                    welshFn = a => a[welshProperties[i]];
                    break;
                }
            }
        }

        if (typeof englishFn === typeof undefined || typeof welshFn === typeof undefined) {
            throw new Error(`Undefined language selector: EN: ${!!englishFn}, CY: ${!!welshFn}`);
        }

        const select = (twoLetterLanguageCode, object, englishFn, welshFn) => {
            switch (twoLetterLanguageCode.toLowerCase()) {
                case "en":
                    return englishFn(object);
                case "cy":
                    return welshFn(object);
                default:
                    console.warn(`No valid page language! ${twoLetterLanguageCode}`);
                    return englishFn(object);
            }
        };

        return select(document.documentElement.lang || "en", object, englishFn, welshFn);
    }
};

class StationDetailComponent {
    constructor(options) {
        this.station = options.station;
        this.parametersComponents = {};
        this._dataExpanded = false;
        this.element = null;
        this.isPopup = options.isPopup;

        this.LinkBuilder = options.LinkBuilder;
        this.moment = options.moment;
        this.Constants = options.Constants; //TRANSPARENT_PIXEL_DATA_URI
        this.text = options.text; //stationTitle: Language.text(station.title)
                                  //stationStatusText: Language.text(this.station.statusText)
                                  //lessData: Resource.LessData
                                  //viewLessData: Resource.ViewLessData
                                  //moreData: Resource.MoreData
                                  //viewMoreData: Resource.ViewMoreData
                                  //viewGraph: Resource.ViewGraph
                                  //graph: Resource.Graph
                                  //upToDateReadingNotAvailable: Resource.UpToDateReadingNotAvailable
                                  //rainfallHelpText: Resource.RainfallHelpText
                                  //rainfallHelpText: Resource.RainfallHelpText
                                  //viewRiverLevelGraph: Resource.ViewRiverLevelGraph
                                  //viewRainfallLevelGraph: Resource.ViewRainfallLevelGraph
                                  //viewTidalLevelGraph: Resource.ViewTidalLevelGraph
                                  //offline: resource.Offline
                                  //levelFalling: resource.LevelFalling
                                  //levelSteady: resource.LevelSteady
                                  //levelRising: resource.LevelRising
                                  //rainfallDry: resource.RainfallDry
                                  //rainfallLightRain: resource.RainfallLightRain
                                  //rainfallModerateRain: resource.RainfallModerateRain
                                  //rainfallHeavyRain: resource.RainfallHeavyRain

        this.text.stationTitle = Language.text(this.station.title);
        this.text.stationStatusText = Language.text(this.station.statusText);
    }

    set dataExpanded(value) {
        this._dataExpanded = value;
        this._updateDataExpandedViewState();
    }

    get dataExpanded() {
        return this._dataExpanded;
    }

    update(station) {
        this.station = station;

        // Update station details
        let statusImage = this.getStationStatusImage();
        $(this.components.statusImage.element).replaceWith(statusImage);
        this.components.statusImage.element = statusImage;

        let statusText = this.getStationStatusSpan();
        $(this.components.statusSpan.element).replaceWith(statusText);
        this.components.statusSpan.element = statusText;

        // Update parameter details
        for (let i = 0; i < station.parameters.length; i++) {
            let parameter = station.parameters[i];

            if (!(parameter.id in this.parametersComponents)) {
                continue;
            }

            let parameterComponents = this.parametersComponents[parameter.id];
            
            let parameterDetails = this.getStationParameterDetailElements(parameter);
            $(parameterComponents.details.element).replaceWith(parameterDetails);
            parameterComponents.details.element = parameterDetails;

            let parameterStatusImageContainer = this.getStationParameterStatusImageContainer(parameter);
            $(parameterComponents.statusImageContainer.element).replaceWith(parameterStatusImageContainer);
            parameterComponents.statusImageContainer.element = parameterStatusImageContainer;
        }
    }

    //private
    _updateDataExpandedViewState() {
        if (this.element === null) {
            return;
        }
        let $station = $(this.element);
        let $graphButton = $station.find(".station-detail__button--graph");
        let $button = $station.find(".station-detail__button--show-more");
        let $parameters = $station.find(".station-parameter");

        if (this._dataExpanded) {
            $button.html(
                `<span class="mobile-only">${this.text.lessData}</span>
                <span class="no-mobile">${this.text.viewLessData}</span>`
            );
            $button.addClass("station-detail__button--show-more-minus");
            $graphButton.hide();

            $parameters.each((index, item) => {
                let $parameter = $(item);
                let $parameterGraphButton = $parameter.find(".station-parameter__button--graph");

                $parameter.removeClass("station-parameter--hidden");
                $parameterGraphButton.removeClass("station-parameter__button--hidden");
            });

        } else {
            $button.html(
                `<span class="mobile-only">${this.text.moreData}</span>
                <span class="no-mobile">${this.text.viewMoreData}</span>`
            );

            $graphButton.show();
            $button.removeClass("station-detail__button--show-more-minus");

            $parameters.each((index, item) => {
                let $parameter = $(item);
                let isFirst = index === 0;
                let $parameterGraphButton = $parameter.find(".station-parameter__button--graph");

                if (!isFirst) {
                    $parameter.addClass("station-parameter--hidden");
                }
                $parameterGraphButton.addClass("station-parameter__button--hidden");
            });
        }

        $station.trigger("layoutChanged");
    }

    //private
    _renderParameter(station, parameter, isPopup, isHidden) {
        var modifier = this.isPopup ? "station-parameter--popup " : "";
        modifier += isHidden ? "station-parameter--hidden" : "";
        
        this.parametersComponents[parameter.id] = {
            details: Html.staticComponent(this.getStationParameterDetailElements(parameter)),
            statusImageContainer: Html.staticComponent(this.getStationParameterStatusImageContainer(parameter)),
        };

        var parameterTypeIcon = this.getParameterTypeIcon(parameter);
        var graphButtonTooltip = this.getGraphButtonText(parameter) || "";
        var graphButtonModifier = isPopup ? " station-parameter__button--hidden" : "";

        return Html.renderTemplate(` 
            <li class="station-parameter ${modifier}"> 
                <img class="station-parameter__icon station-parameter__icon--type" 
                alt="" 
                aria-hidden="true"` /* Hidden as the image label is repeated immediately after the icon */ 
                + `src="${Html.escape(parameterTypeIcon.src)}" />
                
                <div data-component="details"></div>

                <div class="station-parameter__right-container">
                    <div data-component="statusImageContainer"></div>
                    <span class="sro">, </span>
                    <a class="button button--primary station-parameter__button station-parameter__button--graph ${graphButtonModifier}" 
                    href="${this.LinkBuilder.linkToGraph(station, parameter.typeId)}" 
                    class="station-parameter__button station-parameter__button--graph ${graphButtonModifier}"
                    data-tooltip="${graphButtonTooltip}"
                    aria-label="${graphButtonTooltip}: ${this.text.stationTitle}"
                    >
                        <span class="${isPopup ? "sro" : "no-mobile"}">${this.text.viewGraph}</span>
                    </a>
                </div>
            </li>
        `, this.parametersComponents[parameter.id])[0];
    }

    //overridden
    render() {
        if (this.element !== null) {
            return this.element;
        }

        let station = this.station;
        let isPopup = this.isPopup;
        var modifier = isPopup ? "station-detail--popup" : "station-list__item";

        var showMore = station.parameters.length > 1;
        var graphParameterType = null;
        var showMoreHtml = "";
        var graphButtonHtml = "";
        let graphButtonTooltip = "";
        let stationComment = "";
        if (station.parameters.length > 0) {
            graphParameterType = station.parameters[0].typeId;
            graphButtonTooltip = this.getGraphButtonText(station.parameters[0]) || "";
        }

        if (showMore) {
            showMoreHtml =
                `<button class="station-detail__button station-detail__button--show-more">
                    <span class="mobile-only">${this.text.moreData}</span>
                    <span class="no-mobile">${this.text.viewMoreData}</span>
                </button>`;
        }

        if (isPopup && graphParameterType !== null) {
            graphButtonHtml = `
                <a class="station-detail__button station-detail__button--graph button" href="${this.LinkBuilder.linkToGraph(station, graphParameterType)}" data-tooltip="${graphButtonTooltip}">
                    <span class="mobile-only">${this.text.graph}</span>
                    <span class="no-mobile">${this.text.viewGraph}</span>
                </a>
                `;
        }

        if (!isPopup && station.comment) {
            stationComment = `${station.comment}`;
        }

        //design state that if it is a list view item and only has one parameter then hide the footer.
        let hideFooter = !isPopup && station.parameters.length < 2 && !station.comment;

        let parameters = [];
        station.parameters.forEach((param, index) => {
            var isHidden = index > 0;
            parameters.push(this._renderParameter(station, param, isPopup, isHidden));
        });

        let footerHtml = `
                <div class="station-detail__footer">
                    ${stationComment}
                    ${graphButtonHtml}
                    ${showMoreHtml}
                </div>`;

        if (hideFooter) {
            footerHtml = "";
        }

        this.components = {
            statusSpan: Html.staticComponent(this.getStationStatusSpan()),
            statusImage: Html.staticComponent(this.getStationStatusImage()),
            parameters: Html.staticComponent(parameters)
        }

        let htmlString = `
            <div class="station-detail ${modifier}">
                <div class="station-detail__header">
                    <div class="station-detail__icon-frame">
                        <div data-component="statusImage"></div>
                    </div>
                    <a href="${this.LinkBuilder.linkToGraph(station)}" class="station-detail__heading">
                        ${this.text.stationTitle}
                    </a>
                    <div data-component="statusSpan"></div>
                </div>

                <ul class="station-detail__parameters-container">
                    <div data-component="parameters"></div>
                </ul>
                ${footerHtml}
            </div>
        `;
        
        this.element = Html.renderTemplate(htmlString, this.components)[0];
        this.element.component = this;
        return this.element;
    }

    getStationStatusSpan() {
        return $("<span class=\"station-detail__state\"></span>").text(this.text.stationStatusText)[0];
    }

    getStationStatusImage() {
        let icon = this.getStationTypeIconFromParameters(this.station);
        return $("<img class=\"station-detail__icon\" />")
            .attr("src", icon.src)
            .attr("alt", "");
    }

    getStationParameterDetailElements(parameter) {
        let div = $("<div class=\"station-parameter__left-container station-parameter__details\"></div>");

        if (parameter.status === 0) {
            div.append($("<span class=\"station-parameter__notice\"></span>").text(this.text.upToDateReadingNotAvailable));
        } else {
            div.append([
                $("<span class=\"station-parameter__title\"></span>").text(Language.text(parameter.typeText))[0],
                "<span class=\"sro\">, </span>",
                $("<span class=\"station-parameter__value\"></span>").text((Math.round(parameter.latestValue * 1000) / 1000) + parameter.unit)[0],
                "<span class=\"sro\">, </span>",
                $("<span class=\"station-parameter__date\"></span>")
                    .text(this.moment(parameter.latestTime).format('DD/MM/YYYY HH:mm'))
                    .append("<span class=\"sro\">, </span>")
                    .append(parameter.typeId === ParameterType.rainfall
                            ? $([
                                document.createTextNode(' '),
                                $("<i class=\"info-icon\"></i>").attr("data-tooltip", this.text.rainfallHelpText).attr("aria-label", this.text.ainfallHelpText).get(0),
                                $("<span class=\"sro\">, </span>").get(0)
                            ])
                            : "")
                    .get(0),
            ]);
        }

        return div[0];
    }

    getStationParameterStatusImageContainer(parameter) {
        let parameterStatusIcon = this.getParameterStatusIcon(parameter, "blue");
        
        if (!parameterStatusIcon) {
            parameterStatusIcon = { 
                src: this.Constants.TRANSPARENT_PIXEL_DATA_URI,
                alt: this.getParameterStatusText(parameter)
            };
        }

        let img = $("<img class=\"station-parameter__icon station-parameter__icon--state\" />")
                    .attr("src", parameterStatusIcon.src)
                    .attr("alt", parameterStatusIcon.alt);


        let div = $("<div class=\"station-parameter__img-container\"></div>")
                    .attr("data-tooltip", parameterStatusIcon.alt)
                    .append(img);

        return div[0];
    }

    //imported
    getStationTypeIconFromParameters(station) {
        let parameters = station.parameters.slice(0); // clone array before sorting

        if (parameters.length === 0) {
            return this.getStationStatusIcon(station);
        }

        parameters.sort((a, b) => a.typeId - b.typeId);

        return {
            src: `/images/pins/${parameters.length}-${parameters.map(p => p.typeId).join("__")}--horizontal.svg`,
            alt: parameters.map(p => Language.text(p.typeText)).join(" / ")
        };
    }

    getParameterTypeIcon(parameter) {
        let type = parameter.typeId;

        if (!type) {
            throw new Error("Station parameter's type is undefined");
        }

        return {
            src: `/images/pins/1-${type}--horizontal.svg`,
            alt: Language.text(parameter.typeText)
        };
    }

    getParameterStatusIcon(parameter, colour) {
        return {
            src: `/images/status/parameter-${parameter.status}-${colour}.svg`,
            alt: this.getParameterStatusText(parameter)
        };
    }

    getParameterStatusText(parameter) {
        let statuses = {
            0: this.text.offline,
            1: this.text.levelFalling,
            2: this.text.levelSteady,
            3: this.text.levelRising,
            4: this.text.rainfallDry,
            5: this.text.rainfallLightRain,
            6: this.text.rainfallModerateRain,
            7: this.text.rainfallHeavyRain
        };

        if (!statuses[parameter.status]) {
            return null;
        }

        const statusText = statuses[parameter.status];

        if (statusText === null) {
            return null;
        }

        let cleanStatusText = "";
        if (statusText.indexOf("level") >= 0) {
            cleanStatusText = Resource.Water + " " + statusText.replace("--", " ");
        } else {
            cleanStatusText = statusText.replace("--", " ");
        }

        return cleanStatusText;
    }

    getGraphButtonText(parameter) {
        let types = {
            1: this.text.viewRiverLevelGraph,
            2: this.text.viewRainfallLevelGraph,
            3: this.text.viewTidalLevelGraph
        };

        if (!types[parameter.typeId]) {
            return null;
        }

        return types[parameter.typeId];
    }
    
}

export default StationDetailComponent;